"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextArea = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBTextField = require("../HBTextField/HBTextField.styles");
var _TextAreaBase = _interopRequireDefault(require("./TextAreaBase"));
var _mixins = require("../../styles/mixins");
var TextArea = exports.TextArea = (0, _styledComponents["default"])(_TextAreaBase["default"]).withConfig({
  displayName: "HBTextAreastyles__TextArea",
  componentId: "sc-s0bzfg-0"
})(["&&{", " ", " height:", ";padding:12px;white-space:pre-wrap;word-break:break-word;", "}"], function (props) {
  return (0, _HBTextField.textFieldBaseStyles)(props);
}, _HBTextField.textAreaRoot, function (props) {
  return props.height;
}, (0, _mixins.printCss)("\n            word-break: break-all;\n        "));
//# sourceMappingURL=HBTextArea.styles.js.map